module.exports = __webpack_public_path__ + "static/media/closeIconBlack.8d2277db.svg";